// extracted by mini-css-extract-plugin
export default {"roomTypesModal":"styles_roomTypesModal__htd4W","wrapper":"styles_wrapper__mxI6i","tabWrapper":"styles_tabWrapper__Q6zu1","title":"styles_title__aCk0I","tabs":"styles_tabs__NeBOY"};